import { mapGetters } from 'vuex'
import '@/css/home.scss'

export default {
	computed: {
		...mapGetters({
			host: 'host',
			showDebug: 'showDebug',
			deviceType: 'deviceType',
		}),
	},
}
